import { Labels } from 'src/hooks/useLabels.types';

export const getStatusLabel = <T extends string>(value: T, labels: Labels<T>): string => {
  return labels[value] || String(value);
};
